var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAttending)?_c('badge',{attrs:{"text":_vm.$t('events_attending'),"type":"secondary"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }